<template>
  <div>
    <span>
      <button style="border: none; background: none; margin-right: 5px">
        <feather-icon
          icon="SearchIcon"
          class="cursor-pointer"
          svgClasses="w-5 h-5"
          style="color: #7367f0"
          @click="cariEkstre"
        />
      </button>
    </span>
    <HomeSiparisDetay ref="siparisCek" />
  </div>
</template>
<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import HomeSiparisDetay from "./pazaryeri-components/HomeSiparisDetay.vue";
import state from "../../../store/state";
import Store from "../../../store/store";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    HomeSiparisDetay
  },
  methods: {
    cariEkstre() {
      
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        siparisRef: this.params.data.siparisRef,
      };
      soap.createClient(url, function (err, client) {
        client.magazaGorevListesiDetay(args, function (err, result) {
          if (result.magazaGorevListesiDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.magazaGorevListesiDetayResult);
          vm.$refs.siparisCek.siparisDetayCek(vm.params.data, vm.veriler.jsonData);
        });
      });
    },
  },
};
</script>